// src/utils/dateUtils.js

// Format month for display (2024-05 -> 2024-May)
export const formatMonthForDisplay = (month) => {
  if (!month) return "";
  const [year, monthNum] = month.split("-");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return `${year}-${monthNames[parseInt(monthNum, 10) - 1]}`;
};

// Format month for API (2024-May -> 2024-05)
export const formatMonthForAPI = (month) => {
  if (!month) return "";
  const [year, monthStr] = month.split("-");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthNum = String(monthNames.indexOf(monthStr) + 1).padStart(2, "0");
  return `${year}-${monthNum}`;
};
